import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * Class representing the tableBalanceAdjustmentsView.
 * @extends JetView
 */
export default class tableBalanceAdjustmentsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        var vthis = this; // Reference to the current instance

        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable', // Main data table
                            id: 'datatable', // Unique identifier for the table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            columns: [
                                {
                                    id: 'UserId', // Column identifier
                                    header: _('ID Usuario'), // Column header with localization
                                    width: 100, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'UserName',
                                    header: _('Nombre Usuario'),
                                    width: 250,
                                    sort: 'int',
                                    hidden: !devConfig.getPermAction(
                                        'sensitiveInformationNames',
                                        'Add', // Conditional visibility based on permissions
                                    ),
                                },
                                {
                                    id: 'Currency',
                                    header: _('Moneda'),
                                    width: 80,
                                    sort: 'int',
                                },
                                {
                                    id: 'Points',
                                    header: _('Puntos'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.numberFormat, // Number formatting
                                },
                                {
                                    id: 'PointsToExpire',
                                    header: _('Puntos a expirar'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.numberFormat,
                                },
                                {
                                    id: 'ExpiredPoints',
                                    header: _('Puntos expirados'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.numberFormat,
                                },
                                {
                                    id: 'RedeemedPoints',
                                    header: _('Puntos redimidos'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.numberFormat,
                                },
                            ],
                            onClick: {
                                /**
                                 * Handles the click event on the details button.
                                 * @param {Event} euv - The event object.
                                 * @param {String} id - The ID of the clicked item.
                                 */
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('resume:id', [
                                        item.UserId, // Trigger an event with the UserId
                                    ]);
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('detailsCasino').show(); // Show details for small screens
                                    } else {
                                        $$('dColl').expand(); // Expand details for larger screens
                                        $$('formDetails').clear(); // Clear the details form
                                        $$('a5').scrollTo(0, 1000); // Scroll to a specific position
                                    }
                                },
                            },
                            on: {
                                /**
                                 * Shows an overlay before loading data.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                /**
                                 * Hides the overlay after data is loaded.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay();
                                },
                            },
                            /**
                             * Checks if the table has data and shows a message if not.
                             */
                            ready: function () {
                                if (!this.count()) {
                                    webix.extend(this, webix.OverlayBox);
                                    this.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true, // Enable tooltips
                            math: true, // Enable mathematical operations
                            loadahead: devConfig.getDefaultDataFetch(), // Preload settings
                            pager: 'pagerA', // Pagination component
                        },
                        {
                            type: 'wide',
                            view: 'datatable', // Secondary data table
                            id: 'datatable2', // Unique identifier for the second table
                            css: 'webix_header_border webix_data_border webix_footer_border',
                            select: true,
                            columns: [
                                {
                                    id: 'Currency',
                                    header: _('Moneda'),
                                    width: 80,
                                    sort: 'int',
                                },
                                {
                                    id: 'Points',
                                    header: _('Puntos'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.numberFormat,
                                },
                                {
                                    id: 'PointsToExpire',
                                    header: _('Puntos a expirar'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.numberFormat,
                                },
                                {
                                    id: 'ExpiredPoints',
                                    header: _('Puntos expirados'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.numberFormat,
                                },
                                {
                                    id: 'RedeemedPoints',
                                    header: _('Puntos redimidos'),
                                    width: 150,
                                    sort: 'int',
                                    format: webix.i18n.numberFormat,
                                },
                            ],
                            on: {
                                /**
                                 * Shows an overlay before loading data.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay(
                                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                                    );
                                },
                                /**
                                 * Hides the overlay after data is loaded.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay();
                                },
                            },
                            /**
                             * Checks if the second table has data and shows a message if not.
                             */
                            ready: function () {
                                if (!datatable2.count()) {
                                    webix.extend(datatable2, webix.OverlayBox);
                                    datatable2.showOverlay(
                                        "<div class='no-data' style='margin:75px; font-size:18px;'>" +
                                            _('No hay datos') +
                                            '</div>',
                                    );
                                }
                            },
                            tooltip: true,
                            math: true,
                            loadahead: devConfig.getDefaultDataFetch(),
                            pager: 'pagerB', // Pagination component for the second table
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The main data table.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the main data table
        var url = devConfig.geturlApi() + 'Report/GetPointsUsers'; // API endpoint for fetching data
        var filter = ''; // Filter string for API requests
        var grid2 = $$('datatable2'); // Reference to the secondary data table
        grid2.hide(); // Initially hide the second table
        $$('toolbar').hide(); // Initially hide the toolbar

        /**
         * Event listener for filtering data based on user input.
         * @param {Object} filterData - The filter criteria.
         */
        this.on(this.app, 'balanceAdjustments:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Query string for API
            var typeTable = 0; // Type of table to display (0 or 1)

            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    if (object[i][1] == 0) {
                    } else {
                        typeTable = 1; // Set typeTable based on filter
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - '); // Split date range
                            string1 = string1 + '&dateFrom2=' + date[0]; // Add dateFrom2 to query
                            string1 = string1 + '&dateTo2=' + date[1]; // Add dateTo2 to query
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Parse start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Parse end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add dateTo to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            if (typeTable == 0) {
                grid.show(); // Show the main grid
                grid2.hide(); // Hide the secondary grid
                grid.clearAll(); // Clear existing data
                grid.load(
                    url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with filters
                );
                $$('toolbar').show(); // Show the main toolbar
                $$('toolbar2').hide(); // Hide the secondary toolbar
            } else {
                grid2.show(); // Show the secondary grid
                grid.hide(); // Hide the main grid
                grid2.clearAll(); // Clear existing data
                grid2.load(
                    url + '?start=0&count=' + grid.data.$pagesize + string1, // Load data with filters
                );
                $$('toolbar2').show(); // Show the secondary toolbar
                $$('toolbar').hide(); // Hide the main toolbar
            }
            grid.clearAll(); // Clear the main grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load data with filters
            filter = string1; // Update the filter string
            $$('filterPopup').hide(); // Hide the filter popup
        });

        /**
         * Event listener for sorting the grid.
         * @param {String} by - The field to sort by.
         * @param {String} dir - The direction of sorting.
         * @param {Boolean} as - Whether to sort as a string.
         */
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });

        /**
         * Event listener for item click in the grid.
         * @param {String} id - The ID of the clicked item.
         * @param {Event} e - The event object.
         * @param {HTMLElement} node - The clicked node.
         */
        grid.attachEvent('onItemClick', function (id, e, node) {
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger an event with the item ID
        });

        /**
         * Event listener for player selection.
         * @param {String} Id - The ID of the selected player.
         */
        this.on(this.app, 'player:select', (Id) => {
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data filtered by PlayerId
            );
        });
    }
}

// FILE DOCUMENTED
